import React from "react";
const variantStyles = {
    success: {
        color: "#065E49",
        bg: "#22C55E3D",
        shadowColor: "rgba(34, 197, 94, 0.24)",
    },
    warning: {
        color: "#7A0916",
        bg: "#FF56303D",
        shadowColor: "rgba(255, 86, 48, 0.24)",
    },
};
export const SignalMeter = ({ width = 60, height = 52, variant = "success", }) => {
    const { color, bg, shadowColor } = variantStyles[variant];
    return (React.createElement("div", { style: {
            width,
            height,
            borderRadius: 16,
            backgroundColor: bg,
            boxShadow: `0px 8px 18px 0px ${shadowColor}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
        } },
        React.createElement("svg", { width: width * 0.53, height: height * 0.4, viewBox: "0 0 32 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.486793 6.28744C4.67268 2.23237 10.181 0 16.0004 0C21.8182 0 27.3265 2.23237 31.5124 6.28744C32.1473 6.90035 32.1633 7.91491 31.5539 8.55022C30.9397 9.18713 29.9283 9.20473 29.2982 8.58863C25.709 5.11445 20.9871 3.20053 16.0004 3.20053C11.0137 3.20053 6.29183 5.11445 2.70257 8.58863C2.39309 8.88948 1.99269 9.0383 1.59388 9.0383C1.17753 9.0383 0.759578 8.87507 0.446913 8.55022C-0.16406 7.91491 -0.146513 6.90035 0.486793 6.28744Z", fill: color }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.9998 8.00102C19.873 8.00102 23.6377 9.60288 26.3289 12.3985C26.9383 13.0355 26.9223 14.0484 26.2874 14.6613C25.6557 15.2758 24.6427 15.2582 24.0318 14.6229C21.9404 12.4482 19.0132 11.2015 15.9998 11.2015C12.9864 11.2015 10.0591 12.4482 7.9678 14.6229C7.65513 14.9478 7.23718 15.111 6.81923 15.111C6.42042 15.111 6.02002 14.9622 5.71214 14.6613C5.07724 14.0484 5.06129 13.0355 5.67066 12.3985C8.36182 9.60288 12.1266 8.00102 15.9998 8.00102Z", fill: color }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.9997 16.0024C18.0783 16.0024 20.0452 16.8009 21.5399 18.2475C22.1732 18.862 22.1908 19.875 21.5798 20.5103C20.9656 21.1472 19.9542 21.1648 19.3241 20.5503C17.5295 18.8124 14.4699 18.8124 12.6752 20.5503C12.3673 20.8496 11.9669 21 11.5681 21C11.1502 21 10.7322 20.8368 10.4196 20.5103C9.80859 19.875 9.82614 18.862 10.4594 18.2475C11.9542 16.8009 13.9211 16.0024 15.9997 16.0024Z", fill: color }))));
};
export default SignalMeter;
